import type { Resource, Season } from '../../types/game'
import { assetUrl } from '../../utils/assets'

interface ResourceIconProps {
  resource: Resource | 'egg' | 'worker' | 'worker_full'
  size?: string
  inverted?: boolean
  className?: string
}

interface SeasonIconProps {
  season: Season
  size?: string
  inverted?: boolean
  className?: string
}

const RESOURCE_SVG: Record<string, string> = {
  nectar: assetUrl('images', 'resources', 'nectar.svg'),
  pollen: assetUrl('images', 'resources', 'pollen.svg'),
  honey: assetUrl('images', 'resources', 'honey.svg'),
  wax: assetUrl('images', 'resources', 'wax.svg'),
  propolis: assetUrl('images', 'resources', 'propolis.svg'),

  egg: assetUrl('images', 'resources', 'egg.svg'),
  worker: assetUrl('images', 'resources', 'worker.svg'),
  worker_full: assetUrl('images', 'resources', 'worker_full.svg'),
}

const RESOURCE_SVG_INV: Record<string, string> = {
  nectar: assetUrl('images', 'resources', 'nectar_inverted.svg'),
  pollen: assetUrl('images', 'resources', 'pollen_inverted.svg'),
  honey: assetUrl('images', 'resources', 'honey_inverted.svg'),
  wax: assetUrl('images', 'resources', 'wax_inverted.svg'),
  propolis: assetUrl('images', 'resources', 'propolis_inverted.svg'),
  egg: assetUrl('images', 'resources', 'egg_inverted.svg'),
  worker: assetUrl('images', 'resources', 'worker_inverted.svg'),
}

const SEASON_SVG: Record<Season, string> = {
  spring: assetUrl('images', 'seasons', 'spring.svg'),
  summer: assetUrl('images', 'seasons', 'summer.svg'),
  autumn: assetUrl('images', 'seasons', 'autumn.svg'),
  winter: assetUrl('images', 'seasons', 'winter.svg'),
}

const SEASON_SVG_INV: Record<Season, string> = {
  spring: assetUrl('images', 'seasons', 'spring_inverted.svg'),
  summer: assetUrl('images', 'seasons', 'summer_inverted.svg'),
  autumn: assetUrl('images', 'seasons', 'autumn_inverted.svg'),
  winter: assetUrl('images', 'seasons', 'winter_inverted.svg'),
}

export function ResourceIcon({ resource, size, inverted, className }: ResourceIconProps) {
  const src = inverted ? RESOURCE_SVG_INV[resource] : RESOURCE_SVG[resource]
  return (
    <img
      src={src}
      alt={resource}
      className={className ? `icon ${className}` : 'icon'}
      style={size ? ({ '--icon-size': size } as React.CSSProperties) : undefined}
    />
  )
}

export function SeasonIcon({ season, size, inverted, className }: SeasonIconProps) {
  const src = inverted ? SEASON_SVG_INV[season] : SEASON_SVG[season]
  return (
    <img
      src={src}
      alt={season}
      className={className ? `icon ${className}` : 'icon'}
      style={size ? ({ '--icon-size': size } as React.CSSProperties) : undefined}
    />
  )
}
